export const getTransformedSliderChoices = (choices) =>
  choices.map(({ text, isSelected }, index, array) => ({
    value: (index / (array.length - 1)) * 100,
    text,
    isSelected,
  }));
